import { useContext } from "react";
import { FlowContext } from "../context/FlowContext";

export default function useFlow() {
  return useContext(FlowContext);
}
